import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Breadcrumbs from "../components/breadcrumbs"
import Reviews from "../components/reviews"

import "../styles/styles.css"

const IndexPage = ({ pageContext: data, location }) => {
  const phone = data

  var serviceCity
  if (location.state) {
    serviceCity = location.state.serviceCity
  } else {
    serviceCity = "Portland, OR"
  }

  return (
    <Layout serviceCity={serviceCity} repairType={phone.name}>
      <SEO
        title={`${phone.name} Repair Services`}
        description={`Looking for ${phone.name} screen repair, battery replacement or other phone repair services in ${serviceCity}, OR. Our techs will repair your ${phone.name} usually within 45 minutes. `}
        author={`PhoneFix Pro ${phone.name} Repair`}
      />
      <section className="section">
        <div className="container">
          <Breadcrumbs pageName={`${phone.name} Repair Services`} />
          <div>
            <div className="columns is-multiline">
              <div className="column">
                <h2 className="is-size-4">{phone.name} Repair Services </h2>
                <p>
                  We provide walk-in {phone.name} repair service in Portland,
                  OR. In most cases your broken {phone.name} repair is completed
                  in under 45 minutes. Whether a {phone.name} broken screen
                  replacement needed, {phone.name} battery replacement, loud
                  speaker or ear-peace replaced we have the parts and service
                  for your {phone.name}.
                </p>
                <div style={{ marginTop: 20 + "px" }}>
                  {phone.imageUrl ? (
                    <img
                      className="phoneDetailsImg"
                      src={phone.imageUrl}
                      alt={`${phone.name} Repair Service`}
                    />
                  ) : (
                    <div></div>
                  )}

                  <h2>{phone.name}</h2>
                  <p>
                    {phone.snippet}{" "}
                    {phone.sourceUrl ? (
                      <a href={phone.sourceUrl}>Source </a>
                    ) : (
                      ""
                    )}
                  </p>
                </div>
              </div>
              <div className="column">
                <div className="card">
                  <div className="card-content" id="screen-replacement">
                    <h3 className="is-size-5">
                      {phone.name} Screen Replacement
                    </h3>
                    <p>
                      {phone.name} cracked screen replacement services are both
                      fast and affordable. In fact, a majority of {phone.name}{" "}
                      screen repairs can be completed within one business day,
                      at our location in Portland, OR if not while you wait
                      in-store.
                    </p>
                  </div>
                </div>
                <div className="card">
                  <div className="card-content">
                    <h3 className="is-size-5">
                      {phone.name} Replace Broken Buttons{" "}
                    </h3>
                    <p>
                      Missing or broken buttons on your {phone.name}, our
                      professional repair techs can help. A quick repair by
                      PhoneFix Pro will get on your way with a fixed{" "}
                      {phone.name} and working buttons.
                    </p>
                  </div>
                </div>

                <div className="card">
                  <div className="card-content">
                    <h3 className="is-size-5">
                      {phone.name} Battery Replacement
                    </h3>
                    <p>
                      An {phone.name} battery that won’t hold its charge can put
                      a serious damper on your productivity. Great News!!!
                      PhoneFix PRO Cell phone repair performs professional{" "}
                      {phone.name} battery replacements so that your{" "}
                      {phone.name} can keep up with your busy lifestyle.
                    </p>
                  </div>
                </div>

                <div className="card">
                  <div className="card-content">
                    <h3 className="is-size-5">
                      {phone.name} Water Damage Diagnostic and Repair
                    </h3>
                    <p>
                      Got your phone wet or dropped it into the water we can
                      help. We can diagnose and will do our best to try to
                      recover your cell phone from water damage.
                      <Link
                        to={`/contact/`}
                        title={`Contact - ${phone.name} Repair Services Portland, OR`}
                      >
                        Visit our Cell Phone Repair location in Portland, OR
                      </Link>
                    </p>
                  </div>
                </div>

                <div className="card">
                  <div className="card-content">
                    <h3 className="is-size-5">
                      {phone.name} Speaker or Earpiece Replacement
                    </h3>
                    <p>
                      Is sound on your cell phone distorted or completely gone?
                      We can help replace earpiece (ear speakers) and loud
                      speakers, so you can enjoy your {phone.name} again.
                    </p>
                  </div>
                </div>

                <div className="card">
                  <div className="card-content">
                    <h3 className="is-size-5">{phone.name} No Signal</h3>
                    <p>
                      We all had the moments were we don't get service, but it's
                      not always the carrier coverage area. Sometimes it's the
                      wireless antenna that needs to be replaced. Bring your
                      phone in and we will diagnose and repair your {phone.name}{" "}
                      wireless signal problems.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ marginTop: 20 + "px" }}>
            <h3 className="is-size-4">
              What Our Customers Are Saying About {phone.name} Repair Services
            </h3>
            <Reviews />
          </div>
          <a
            href="https://search.google.com/local/writereview?placeid=ChIJw-drm5ihlVQRPncfwgrs-ck"
            title={`Repair ${phone.name} Write a Review on Google`}
          >
            Write a Review on Google
          </a>
          <br />
          Back to{" "}
          <Link to={`/${phone.parent.url}`}>
            title=
            {`PhoneFix PRO - ${phone.parent.name} Repair Services Portland, OR`}
            PhoneFix PRO - {phone.parent.name} Repair Services Portland, OR
          </Link>
        </div>
      </section>
    </Layout>
  )
}

export default IndexPage
